function popup() {
    let link__shedule = document.querySelector('#product-details__shedule'),
        popup__shedule = document.querySelector('#popup__shedule'),
        popup__close =document.querySelectorAll('.popup__close'),
        link__address=document.querySelector('#product-details__address'),
        popup__address=document.querySelector('#popup__address');
    if(link__shedule){
        link__shedule.addEventListener('click', (e) => {
            e.preventDefault();
            popup__shedule.classList.toggle('popup__show');
        });
    }
    if(link__address){
        link__address.addEventListener('click',(e) => {
            e.preventDefault();
            popup__address.classList.toggle('popup__show');

        });
    }

    popup__close.forEach((elem) => { 
        elem.classList.remove('popup__show');
    });

    if(document.querySelector('.popup__close-address')) {

        document.querySelector('.popup__close-address').addEventListener('click',()=>{
            popup__address.classList.remove('popup__show');
        });
    }
}
popup();